import {
  TENANT_AT,
  TENANT_BE,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts/tenants'

export const STATIC_URL_BASE_COM = 'https://static.shop-apotheke.com'
export const STATIC_URL_BASE_AT = 'https://static.shop-apotheke.at'
export const STATIC_URL_BASE_CH = 'https://static.shop-apotheke.ch'
export const STATIC_URL_BASE_FR = 'https://static.shop-pharmacie.fr'
export const STATIC_URL_BASE_IT = 'https://static.redcare.it'
export const STATIC_URL_BASE_BE = 'https://static.shop-apotheke.ch'

export const STATIC_URL_MAP = {
  [TENANT_COM]: STATIC_URL_BASE_COM,
  [TENANT_AT]: STATIC_URL_BASE_AT,
  [TENANT_CH]: STATIC_URL_BASE_CH,
  [TENANT_FR]: STATIC_URL_BASE_FR,
  [TENANT_IT]: STATIC_URL_BASE_IT,
  [TENANT_BE]: STATIC_URL_BASE_BE,
}

export const MEDICATION_PLAN_TEST_URL = 'https://med.mediawaves.de'
export const MEDICATION_PLAN_DEV_URL =
  'https://med-shared-services-dev.redteclab.de'
export const MEDICATION_PLAN_QS_URL =
  'https://med-shared-services-qs.redteclab.de'
export const MEDICATION_PLAN_PROD_URL = 'https://med.shop-apotheke.com'
